module.exports = __webpack_public_path__ + "static/media/cia_agent.d40c510c.wav";